import React, { useState } from "react";
import styled from "styled-components";
import { designTokens, getTypography } from "../../styles/designTokens";
import { ReactComponent as VisibleIcon } from "@/assets/icons/visible.svg?react";

const Input = styled.input`
  width: 100%;
  height: 41px;
  border-radius: 4px;
  border: 1px solid rgba(222, 226, 230, 0.83);
  padding: 6px 12px;
  ${getTypography("korean", "body3")}

  &::placeholder {
    color: ${designTokens.colors.font.tertiary};
    opacity: 1;
  }
`;

const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const ErrorText = styled.span`
  color: #dc3545;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  padding-bottom: 16px;
`;

interface RenderPasswordFieldProps {
  label: string;
  name: string;
  placeholder: string;
  error?: boolean;
  hint?: React.ReactNode;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const RenderPasswordField: React.FC<RenderPasswordFieldProps> = ({
  label,
  name,
  placeholder,
  error = false,
  hint = null,
  value,
  onChange,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "4px",
      }}
    >
      <InputWrapper>
        <Input
          type={isVisible ? "text" : "password"}
          name={name}
          value={value || ""}
          onChange={onChange}
          placeholder={placeholder}
          required
          minLength={8}
          maxLength={12}
          style={{ paddingRight: "40px" }}
        />
        <span
          style={{
            position: "absolute",
            right: "12px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            height: "100%",
          }}
          onClick={toggleVisibility}
        >
          <VisibleIcon style={{ opacity: isVisible ? 0.5 : 1 }} />
        </span>
      </InputWrapper>
      {error && <ErrorText>현재 비밀번호가 일치하지 않습니다.</ErrorText>}
      {hint}
    </div>
  );
};

export default RenderPasswordField;
